import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/LangContext";
import { TID } from "../lib/testIds";

export default function Footer() {
  const { t } = useLang();

  const scrollOrGo = (id) => (e) => {
    if (window.location.pathname === "/") {
      e.preventDefault();
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 72;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }
  };

  return (
    <footer
      data-testid={TID.footer}
      className="relative bg-[#0A0A0A] text-white border-t border-white/10 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center gap-3 group">
              <div className="relative">
                <div className="w-14 h-14 bg-[#D4AF37] flex items-center justify-center">
                  <span className="font-display text-black text-3xl font-bold leading-none">Z</span>
                </div>
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#E3000F]">
                  <span className="absolute left-1/2 -translate-x-1/2 top-[2.5px] w-[2px] h-[11px] bg-white" />
                  <span className="absolute top-1/2 -translate-y-1/2 left-[2.5px] h-[2px] w-[11px] bg-white" />
                </span>
              </div>
              <span className="flex flex-col leading-tight">
                <span className="font-display text-white text-2xl">ZEMI SWISS</span>
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">GmbH</span>
              </span>
            </Link>
            <p className="mt-4 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
              {t.footer.tagline}
            </p>
            <p className="mt-6 text-white/60 text-sm max-w-md leading-relaxed">
              Langenlenstrasse 10b<br />
              9100 Herisau, Schweiz
            </p>
            <p className="mt-2 text-white/60 text-sm">
              <a href="tel:+41783215249" className="hover:text-white">+41 78 321 52 49</a> ·{" "}
              <a href="tel:+41782584261" className="hover:text-white">+41 78 258 42 61</a>
            </p>
            <p className="text-white/60 text-sm">
              <a href="mailto:info@zemiswiss.ch" className="hover:text-white">info@zemiswiss.ch</a>
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.3em] text-white/40">
              {t.footer.sections.company}
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href="/#about" onClick={scrollOrGo("about")} className="text-white/80 hover:text-[#D4AF37] gold-link">{t.footer.links.about}</a></li>
              <li><a href="/#services" onClick={scrollOrGo("services")} className="text-white/80 hover:text-[#D4AF37] gold-link">{t.nav.services}</a></li>
              <li><a href="/#contact" onClick={scrollOrGo("contact")} className="text-white/80 hover:text-[#D4AF37] gold-link">{t.footer.links.contact}</a></li>
              <li><a href="/#quote" onClick={scrollOrGo("quote")} className="text-white/80 hover:text-[#D4AF37] gold-link">{t.footer.links.quote}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.3em] text-white/40">
              {t.footer.sections.legal}
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/impressum" data-testid={TID.footerImprint} className="text-white/80 hover:text-[#D4AF37] gold-link">
                  {t.footer.links.imprint}
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" data-testid={TID.footerPrivacy} className="text-white/80 hover:text-[#D4AF37] gold-link">
                  {t.footer.links.privacy}
                </Link>
              </li>
            </ul>
            <div className="mt-8 inline-flex items-center gap-2 text-xs text-white/40">
              <span className="inline-block w-4 h-4 bg-[#E3000F] relative">
                <span className="absolute left-1/2 -translate-x-1/2 top-[3px] w-[2px] h-[10px] bg-white" />
                <span className="absolute top-1/2 -translate-y-1/2 left-[3px] h-[2px] w-[10px] bg-white" />
              </span>
              <span>Made in Switzerland</span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/40">
          <p>{t.footer.copyright}</p>
          <p className="font-mono">CH-9100 · HERISAU</p>
        </div>
      </div>
    </footer>
  );
}
